import React from "react";
import globalStyles from "../../styles/globalStyles.module.css";
import { useExploreContext } from "../../context/ExploreProvider";
import InfiniteScroll from "../../components/InfiniteScroll/InfiniteScroll";

// interface Profile {
//   id: number;
//   name: string;
//   image: string;
// }

const Explore: React.FC = () => {
  const { exploreState } = useExploreContext();

  return (
    <div>
      <div className={globalStyles.pageTitle}>Explore</div>
      <InfiniteScroll
        key={3}
        togglePage={exploreState.togglePage}
        loading={exploreState.loading}
        hasMore={exploreState.hasMore}
      >
        {exploreState.data.map((item, index) => (
          <div key={index}>{item.booster_name}</div>
        ))}
      </InfiniteScroll>
    </div>
  );
};

export default Explore;
